import * as React from 'react';

export interface StarsRatingBarProps {
  dataHook?: string;
  className?: string;
  size?: starRatingBarSize;
  readOnly?: boolean;
  descriptionValues?: [string, string, string, string, string];
  value: starRatingBarValue;
  onChange?: (rate: number) => void;
}

declare const StarsRatingBar: React.ForwardRefExoticComponent<
  StarsRatingBarProps & React.RefAttributes<HTMLInputElement>
>;

export { StarsRatingBar };
export type starRatingBarSize = 'tiny' | 'small' | 'medium' | 'large';
export type starRatingBarValue = 0 | 1 | 2 | 3 | 4 | 5;
